module.exports = __webpack_public_path__ + "img/genie.70b1d8ca.png";